export enum TargetValueOperator {
	In = 1,
	NotIn = 2,
	Equals = 3,
	NotEquals = 4,
	Range = 5,
	All = 6,
}
